export enum DiscountApplicationTypeEnum {
  ByValue = 0,
  ByQuantity = 1
}
